import { useEffect } from 'react';

import { useClosedCollectContext } from '../../../context/ProviderPage/Encerrada';
import { FilterInput } from '../../Inputs/FilterInput';
import { FilterSelectInput } from '../../Inputs/FilterSelectInput';
import { SideMenuFilterTemplete } from '../SideMenuFilterTemplete';

export const FilterClosedCollect = () => {
  const {
    openSideModalFilterClosedCollect,
    openSideModalFilterClosedCollectAction,
    cleanAllInputsAction,
    filterClosedCollectAction,
    DFNOMECARRETEIRO,
    setDFNOMECARRETEIRO,
    DFORDEMCOLETA,
    setDFORDEMCOLETA,
    DFNOMELINHA,
    setDFNOMELINHA,
    DFPLACAVEICULO,
    setDFPLACAVEICULO,
    DFDATACOLETA,
    setDFDATACOLETA,
    DFDATASAIDA,
    setDFDATASAIDA,
    DFBLOQUEIOERP,
    setDFBLOQUEIOERP,
    DFTOTALARMAZENADO,
    setDFTOTALARMAZENADO,
    DFDATAPROGRAMADA,
    setDFDATAPROGRAMADA,
  } = useClosedCollectContext();

  useEffect(() => {
    if (Number(DFORDEMCOLETA) < 0) {
      setDFORDEMCOLETA('0');
    }
  }, [DFORDEMCOLETA]);

  return (
    <SideMenuFilterTemplete
      isOpen={openSideModalFilterClosedCollect}
      onchange={openSideModalFilterClosedCollectAction}
      title="Filtrar Encerrada"
      cleanAllInputsAction={cleanAllInputsAction}
      filterAction={filterClosedCollectAction}
    >
      <FilterInput
        onChange={setDFORDEMCOLETA}
        value={DFORDEMCOLETA}
        title="Ordem Coleta"
        type="number"
        min={0}
      />
      <FilterSelectInput
        onChange={setDFBLOQUEIOERP}
        value={DFBLOQUEIOERP}
        title="Encerrada"
      />
      <FilterInput
        onChange={setDFNOMECARRETEIRO}
        value={DFNOMECARRETEIRO}
        title="Carreteiro"
        type="text"
      />
      <FilterInput
        onChange={setDFTOTALARMAZENADO}
        value={DFTOTALARMAZENADO}
        title="Total em litros"
        type="number"
      />
      <FilterInput
        onChange={setDFPLACAVEICULO}
        value={DFPLACAVEICULO}
        title="Veículo"
        type="text"
      />
      <FilterInput
        onChange={setDFNOMELINHA}
        value={DFNOMELINHA}
        title="Linha"
        type="text"
      />
      <FilterInput
        onChange={setDFDATAPROGRAMADA}
        value={DFDATAPROGRAMADA}
        title="Data Programada"
        type="date"
      />
      <FilterInput
        onChange={setDFDATASAIDA}
        value={DFDATASAIDA}
        title="Data Saída"
        type="date"
      />
      <FilterInput
        onChange={setDFDATACOLETA}
        value={DFDATACOLETA}
        title="Data Coleta"
        type="date"
      />
    </SideMenuFilterTemplete>
  );
};
